var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSlg0)",
    d: "m5.143 15.802l2.142-3.986l4.758 2.091l4.671-2.091l2.143 3.986l-6.814 3.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSlg1)",
    fillRule: "evenodd",
    d: "M11.992 14.19a780 780 0 0 0-4.706-2.374l4.706-2.34l4.723 2.34zm0-.742c-1.059-.535-3.189-1.615-3.227-1.628l3.227-1.603l3.244 1.607l-3.244 1.629zM10.5 12.214l1.5.643l1.5-.647l-1.5-.639l-1.5.639z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSlg2)",
    d: "M12 11.143L8.57 9.634L12 4.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSlg3)",
    d: "m12 11.143l3.429-1.509L12 4.286z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSlg0",
    x1: 11.863,
    x2: 11.863,
    y1: 18.279,
    y2: 12.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A9CFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE6EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSlg1",
    x1: 12,
    x2: 12,
    y1: 9.476,
    y2: 14.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D7FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAFBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSlg2",
    x1: 9.244,
    x2: 11.696,
    y1: 9.947,
    y2: 5.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#70B8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSlg3",
    x1: 14.756,
    x2: 12.304,
    y1: 9.947,
    y2: 5.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#96CEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8F3FC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlg);
export default __webpack_public_path__ + "static/media/slg.30dd4c0d58e42cf38c6c3dc7cb850f98.svg";
export { ForwardRef as ReactComponent };